import React from "react"
import { Drawer } from 'antd';


class SidebarNotifications extends React.Component{
    
    constructor(props){
        super(props);
        this.state = {
          }

    }
    componentWillMount(){
        this.props.loadNotificationQueue();
    
        this.interval = setInterval(() => {
          this.props.loadNotificationQueue()
        }, 10000);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    renderNotifications() {
        let self = this;
        return <ul>
                    {   
                        self.props.lst_notifications.map(function(msg, i) {
                                return (<li className="item" key={i}>
                                <ul>
                                    <li className="header regular">
                                        {msg.title}
                                        <i className="fa fa-times-circle remove clickable" onClick={self.props.handleNotification.bind(self,"remote","remove","",msg._id)}></i>
                                    </li>
                                    <li className="details">    
                                        
                                        <div className="message">
                                            <p>{msg.msg}</p>
                                          <div className="progress">
                                              <div className="progress-bar bg-success" style={{width:msg.progress+"%"}} role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                          </div>
                                        </div>
                                        <div className="datetime">
                                            <i className="clock"></i>
                                            <span className="days">today</span>
                                            <span className="time">{msg.datetime.$date.$numberLong}</span>
                                        </div>
                                    </li>
                        
                                </ul>
                        
                            </li>);
                            })
                    }
                </ul>   
    }
  
  renderNotificationsTmp() {
        let self = this;
        return <ul>
                    {   
                        this.props.lst_tmp_notifications.map(function(msg, i) {
                                return (<li className="item" key={i}>
                                <ul>
                                    <li className="header regular">
                                        {msg.title}
                                        <i className="fa fa-times-circle remove clickable" onClick={self.props.handleNotification.bind(self,"tmp","remove","",i)}></i>
                                    </li>
                                    <li className="details">
                                        <div className="message">
                                            <p>{msg.msg} </p>
                                          <div className="progress">
                                              <div className="progress-bar bg-success" style={{width:msg.progress+"%"}} role="progressbar" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                          </div>
                                        </div>
                                        <div className="datetime">
                                            <i className="clock"></i>
                                            <span className="days">{msg.day}</span>
                                            <span className="time">{msg.datetime}</span>
                                        </div>
                                    </li>
                        
                                </ul>
                        
                            </li>);
                            })
                    }
                </ul>   
    }

    render(){
        return(
            <Drawer
              title="Notifications"
              placement="right"
              closable={true}
              onClose={this.props.onCloseNotifications}
              visible={this.props.status_sb_notifications}
              width="330px"
            >
              <div className="list">
                  {this.renderNotificationsTmp()}
              </div>
              <div className="list">
                  {this.renderNotifications()}
              </div>
            </Drawer>
        )}
}

export default SidebarNotifications


// WEBPACK FOOTER //
// ./src/Setup/components/SidebarNotifications.js